import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IPmPayer {
  Id: string
  Name: string
  Address: string
  City: string
  State: string
  ZipCode: string
  ReceiverId: string
  TableReference: string
  FieldReference: string
  CompositeName: string
  HealthPlanId: number
}

@Injectable()
export class PmPayerODataService extends ODataService<IPmPayer> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'Payers'
  }
}
